import BaseFilter from './BaseFilter';
import { requestGetLicenseNumbers as request } from '../../../state/ducks/filters/api';

const LicenseNumberFilter = ({ value, requestQueryParams, onChange }) => BaseFilter({ value, onChange, request, requestQueryParams });

LicenseNumberFilter.defaultProps = BaseFilter.defaultProps;

export default LicenseNumberFilter;
